import React from 'react';
import ReactDOM from 'react-dom/client';
// https://stackoverflow.com/questions/66747556/react-js-error-uselocation-may-be-used-only-in-the-context-of-a-router-com
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { store } from './store';
import { Provider } from 'react-redux';
import './styles/bootstrap.scss';
import { Helmet, HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Smash API</title>
      </Helmet>
      <Router>
        <Provider store={store}>
          <App />
        </Provider>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

